import React, { forwardRef } from 'react';
import classNames from 'classnames';

type Props = React.HTMLAttributes<HTMLTableSectionElement>;

const TableBody = forwardRef<HTMLTableSectionElement, Props>(({ children = null, className, ...rest }, ref) => (
  <tbody {...rest} ref={ref} className={classNames('divide-y divide-gray-200 bg-white', className)}>
    {children}
  </tbody>
));

export default TableBody;
